import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Communications Fill
 */

export default function CommunicationsFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M8 4C9.10457 4 10 4.89543 10 6V9.74491C10 10.8495 9.10457 11.7449 8 11.7449H4.1091L2.16779 13.9326C2.04567 14.0702 1.8182 13.9838 1.8182 13.7998V11.7368C0.798827 11.6449 0 10.7882 0 9.74491V6C0 4.89543 0.895431 4 2 4H8Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.98071 3C5.98071 1.89543 6.87614 1 7.98071 1H14.0002C15.1048 1 16.0002 1.89543 16.0002 3V6.7443C16.0002 7.78878 15.1996 8.64626 14.1785 8.73646V10.7998C14.1785 10.9837 13.9512 11.0702 13.8291 10.9327L11.8831 8.7443H11V5C11 3.89543 10.1046 3 9 3L5.98071 3Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
